<!-- This file is auto-generated don't edit it! -->
<h1 id="preview">Preview</h1>
<p><ui-date-picker-docs-preview></ui-date-picker-docs-preview></p>
<h1 id="description">Description</h1>
<p>Datepicker component to pick single date or period.</p>
<h1 id="usage">Usage</h1>
<pre><code class="language-html">Period picker with end date limitation
<span class="hljs-tag">&lt;<span class="hljs-name">ui-date-picker</span>
    [<span class="hljs-attr">dateSpanPicker</span>]=<span class="hljs-string">"true"</span>
    [(<span class="hljs-attr">startDate</span>)]=<span class="hljs-string">"periodDateStart"</span>
    [(<span class="hljs-attr">endDate</span>)]=<span class="hljs-string">"periodDateEnd"</span>
    [<span class="hljs-attr">maxDate</span>]=<span class="hljs-string">"maxDate"</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">ui-date-picker</span>&gt;</span></code></pre>
<h1 id="inputs">Inputs</h1>
<table>
<thead>
<tr>
<th align="left">Property</th>
<th align="left">Description</th>
</tr>
</thead>
<tbody><tr>
<td align="left">date</td>
<td align="left">Datepicker date if not period</td>
</tr>
<tr>
<td align="left">startDate</td>
<td align="left">Start date if period datepicker</td>
</tr>
<tr>
<td align="left">endDate</td>
<td align="left">End date if period datepicker</td>
</tr>
<tr>
<td align="left">hourPicker</td>
<td align="left">Is datepicker with hours picker</td>
</tr>
<tr>
<td align="left">dateSpanPicker</td>
<td align="left">Is period datepicker</td>
</tr>
<tr>
<td align="left">maxDate</td>
<td align="left">Maximum date limitation of datepiker</td>
</tr>
<tr>
<td align="left">minDate</td>
<td align="left">minimum date limitation of datepiker</td>
</tr>
<tr>
<td align="left">firstWeekdaySunday</td>
<td align="left">Week starts with Sunday</td>
</tr>
<tr>
<td align="left">outerBorders</td>
<td align="left">Show outer borders</td>
</tr>
</tbody></table>
<h1 id="outputs">Outputs</h1>
<table>
<thead>
<tr>
<th align="left">Property</th>
<th align="left">Description</th>
</tr>
</thead>
<tbody><tr>
<td align="left">dateChange</td>
<td align="left">Output event that single date is changed, return type is Date</td>
</tr>
<tr>
<td align="left">startDateChange</td>
<td align="left">Output event that start date of period is changed, return type is Date</td>
</tr>
<tr>
<td align="left">endDateChange</td>
<td align="left">Output event that end date of period is changed, return type is Date</td>
</tr>
</tbody></table>
